import { hydrateFromWorker } from '@/models/hydrate-worker-utils';
import {
  dealStore,
  favoriteStore,
  hubStore,
  primaryCustomerStore,
} from '@/models/stores';
import { useEffect } from 'react';

const useSideBarHydrateLocal = () => {
  useEffect(() => {
    const hydrateSideBar = async () => {
      // UX NOTE: we only need to hydrate the hubs to get a good initial loading UX
      // the rest of the data will be hydrated elsewhere
      await Promise.all([hubStore.hydrateLocal()]).then(() => {});

      await Promise.all([
        favoriteStore.hydrateLocal(),
        primaryCustomerStore.hydrateLocal(),
      ]);

      const favoriteDeals = await favoriteStore.favorites;
      const favoriteDealIds = favoriteDeals.map((favorite) => favorite.deal_id);
      await hydrateFromWorker({
        tableName: 'core_deals',
        entity: 'core_deals',
        modelStore: dealStore,
        ids: favoriteDealIds,
      });
    };

    hydrateSideBar();
  }, []);
};

export default useSideBarHydrateLocal;
